module.exports = __webpack_public_path__ + "images/emails/inbound-graph-54e9b853.gif";